import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BackbaseCoreModule, ItemModel } from '@backbase/foundation-ang/core';
import {
    AlertModule,
    AmountModule,
    ButtonModule,
    EmptyStateModule,
    HeaderModule,
    InputTextModule,
    InputValidationMessageModule,
    LoadingIndicatorModule,
    ModalModule,
    IconModule,
    ProgressbarModule,
    DropdownSingleSelectModule, InputRadioGroupModule,
} from '@backbase/ui-ang';
import {
  TransactionSigningInterfaceComponent,
  TransactionSigningInterfaceCustomizableDirective,
} from './components/bb-transaction-signing-interface/interface.component';
import {
  TransactionSigningActionPendingComponent,
  TransactionSigningActionPendingCustomizableDirective,
} from './components/customisable-components/bb-transaction-signing-action-pending/action-pending.component';
import {
  TransactionSigningErrorComponent,
  TransactionSigningErrorCustomizableDirective,
} from './components/customisable-components/bb-transaction-signing-error/error.component';
import {
  TransactionSigningHeaderComponent,
  TransactionSigningHeaderCustomizableDirective,
} from './components/customisable-components/bb-transaction-signing-header/header.component';
import { TransactionSigningHardTokenComponent } from './components/signing-components/bb-hard-token-signing/hard-token.component';
import { TransactionSigningOobSelectDeviceComponent } from './components/signing-components/bb-oob-select-device/oob-select-device.component';
import { TransactionSigningOobDeviceComponent } from './components/signing-components/bb-oob-device-signing/oob-device.component';
import { TransactionSigningSmsOtpComponent } from './components/signing-components/bb-sms-otp-signing/sms-otp.component';
import { TransactionSigningWidgetComponent } from './transaction-signing-widget.component';
import { of } from 'rxjs';

const widgetComponents = [
  TransactionSigningWidgetComponent,
  TransactionSigningErrorComponent,
  TransactionSigningInterfaceComponent,
  TransactionSigningActionPendingComponent,
  TransactionSigningHeaderComponent,
  TransactionSigningErrorCustomizableDirective,
  TransactionSigningInterfaceCustomizableDirective,
  TransactionSigningActionPendingCustomizableDirective,
  TransactionSigningHeaderCustomizableDirective,
];

const signingComponents = [
  TransactionSigningHardTokenComponent,
  TransactionSigningOobSelectDeviceComponent,
  TransactionSigningOobDeviceComponent,
  TransactionSigningSmsOtpComponent,
];

const uiComponents = [
  ModalModule,
  HeaderModule,
  ButtonModule,
  ReactiveFormsModule,
  AmountModule,
  InputTextModule,
  InputValidationMessageModule,
  LoadingIndicatorModule,
  EmptyStateModule,
  AlertModule,
  IconModule,
  ProgressbarModule,
  DropdownSingleSelectModule,
];

const widgetProperties: { [key: string]: any } = {
  "pollingCycleTime": 3000,
  "enableResendPushNotification": false
};
const itemModelStub = {
  properties: of({}),
  property: (key: string) => of(widgetProperties[key]),
};


@NgModule({
  declarations: [...widgetComponents, ...signingComponents],
  imports: [
      CommonModule,
      BackbaseCoreModule.withConfig({
          classMap: {TransactionSigningWidgetComponent},
      }),
      ...uiComponents,
      InputRadioGroupModule,
  ],
  providers: [
    // {
    //   provide: ItemModel,
    //   useValue: itemModelStub
    // }
  ],
  exports: [...widgetComponents, ...signingComponents, ...uiComponents],
})
export class TransactionSigningWidgetModule {}
